import { NavLink } from "react-router-dom";
import { Home, Heart, BookOpen, Settings, User } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function BottomNav() {
  const { user } = useAuth();
  const isAuth = !!user;
  const items = [
    { to: "/", label: "Accueil", icon: Home, testid: "nav-home" },
    { to: "/favoris", label: "Favoris", icon: Heart, testid: "nav-favorites" },
    {
      to: isAuth ? "/mon-espace" : "/connexion",
      label: isAuth ? "Mon espace" : "Connexion",
      icon: User,
      testid: isAuth ? "nav-my-space" : "nav-login",
    },
    { to: "/methodes", label: "Méthodes", icon: BookOpen, testid: "nav-methods" },
    { to: "/reglages", label: "Réglages", icon: Settings, testid: "nav-settings" },
  ];
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-40 safe-bottom px-3"
    >
      <div className="rounded-2xl border border-[color:var(--border)] bg-[#0D1B2A]/85 backdrop-blur-xl px-1 py-2 flex justify-between shadow-2xl">
        {items.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={testid}
            to={to}
            end={to === "/"}
            data-testid={testid}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center gap-1 py-2 rounded-xl transition-colors ${
                isActive ? "text-[color:var(--sauge-light)]" : "text-[color:var(--ivoire-subtle)] hover:text-[color:var(--ivoire)]"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={18} strokeWidth={1.6} />
                <span className="text-[10px] tracking-wide">{label}</span>
                {isActive && <span className="w-1 h-1 rounded-full bg-[color:var(--sauge)]" />}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
